import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const ENCRYPT_SECRET_KEY = localStorage.getItem('token') || '';
@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  encryptValue(value: string, key: string = ENCRYPT_SECRET_KEY): string {
    const keyWordArray = CryptoJS.enc.Utf8.parse(key.padEnd(32, ' ')); // Ensure 32-byte key
    const iv = CryptoJS.lib.WordArray.random(16); // Generate a 16-byte IV

    const encrypted = CryptoJS.AES.encrypt(value, keyWordArray, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Convert IV and ciphertext to Base64 and concatenate
    return `${CryptoJS.enc.Base64.stringify(iv)}:${encrypted.ciphertext.toString(CryptoJS.enc.Base64)}`;
  }

  decryptValue(encryptedString: string, key: string | null = ENCRYPT_SECRET_KEY): string {
    try {
      if (!encryptedString || !key) {
        return '';
      };
      const [ivBase64, encryptedBase64] = encryptedString.split(':');
      if (!ivBase64 || !encryptedBase64) throw new Error("Invalid encrypted format");

      // Decode IV and ciphertext from Base64
      const iv = CryptoJS.enc.Base64.parse(ivBase64);
      const encryptedData = CryptoJS.enc.Base64.parse(encryptedBase64);

      // Ensure key is 32 bytes
      const keyWordArray = CryptoJS.enc.Utf8.parse(key.padEnd(32, ' '));

      // Perform AES decryption
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedData } as any,
        keyWordArray,
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      );

      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      if (!decryptedText) throw new Error("Decryption resulted in an empty string.");

      return decryptedText;
    } catch (error) {
      console.error("Decryption failed:", error);
      return '';
    }
  }

}
